import { ButtonBase, CircularProgress, makeStyles, TextField, Toolbar, Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import { HelpOutline } from '@material-ui/icons';
import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';
import { ACTION_TYPES, CHARACTER_LIMIT, ENVIRONMENT_tYPE, GROUP_TYPES,URL_PATH, LIVE_DELETE_MESSAGE, LIVE_MODALMESSAGE, STAGING_DELETE_MESSAGE, STAGING_MODALMESSAGE, DECODE_URL_PATH } from 'components/common/constants/Constant';
import Footer from 'components/common/footer/Footer';
import Header from 'components/common/header/Header';
import SubmitAlertModal from 'pages/editors/SubmitAlertModal';
import { default as React, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { saveAnnouncementsStart } from 'redux/actions/announcement.action';
import { fetchAnnouncementaudioAudioStart } from 'redux/actions/announcementAudio.action';
import Breadcrumb from '../../components/common/breadcrumb/breadcrumb';
import DeleteAlert from '../editors/DeleteAlert';
import styles from '../editors/RoadCondition.module.scss';

const useStyles = makeStyles({
    root: {
        flexGrow: 1,
    },
    pageMargin: {
        margin: "0 6%",
        minHeight: '480px'
    },
    marginTop: {
        marginTop: '3%'
    },
    button: {
        // margin: 0,
        fontSize: '14px',
        color: 'blue',
    },
    rectBox: {
        margin: '3% 0 !important'
    }
});
const breacrumbItems = [
    {
        label: "Home",
        href: "/"
    },
    {
        label: "Avalanche Announcements",
        href: "/announcements"
    }
];

const EditorPage = (props) => {
    const classes = useStyles();
    const { groupType, actionType } = useParams();
    const history = useHistory();
    const state = history.location.state;
    const dispatch = useDispatch();
    const [announcementMessage, setMessage] = useState({});
    const [textMessage, setTextMessage] = useState("");
    const [showEditIcon, setShowEditIcon] = useState(true);
    const [isSubmittedToUat, setIsSubmittedToUat] = useState(false);
    const [isProdSubmit, setIsProdSubmit] = useState(false);
    const [showSubmitAlertModal, setShowSubmitAlertModal] = useState(false);
    const announcementState = useSelector((state) => state.announcements);
    const [isNotShowPlayButton, setNotShowPlayButton] = useState({});
    const audioState = useSelector((state) => state.announcementAudio);
    const [isPreviewed, setIsPreviewed] = useState(false);
    useEffect(() => {
        breacrumbItems.splice(2);
        console.log(groupType)
        if (!(actionType && (Object.values(ACTION_TYPES).indexOf(actionType) !== -1)
            && DECODE_URL_PATH[ groupType] && (Object.values(GROUP_TYPES).indexOf(DECODE_URL_PATH[ groupType]) !== -1)
            && state && state.announcement)) {
            history.push('/announcements');

        }
        else if (actionType === ACTION_TYPES.NEW) {
            setMessage({
                announcementType: state.announcement.announcementType,
                message: "",
                environment: state.announcement.environment,
                description: state.announcement.description,
                lastModifiedDateTime: state.announcement.lastModifiedDateTime,
                lastModifiedUserName: state.announcement.lastModifiedUserName
            })
            setIsSubmittedToUat(false);
            breacrumbItems.push({ label:  DECODE_URL_PATH[ groupType], href: '/announcements/' +  groupType });
            breacrumbItems.push({ label: actionType });
        }
        else if (actionType === ACTION_TYPES.EDIT) {
            setMessage({
                announcementType: state.announcement.announcementType,
                message: state.announcement.message,
                environment: state.announcement.environment,
                description: state.announcement.description,
                lastModifiedDateTime: state.announcement.lastModifiedDateTime,
                lastModifiedUserName: state.announcement.lastModifiedUserName
            });
            if (state.announcement.message.trim() !== '') setIsSubmittedToUat(true);
            breacrumbItems.push({ label:  DECODE_URL_PATH[ groupType], href: '/announcements/' +   groupType });
            breacrumbItems.push({ label: actionType });
        }
    }, [])
    const successToast = (toastMessage) => {
        toast.success(toastMessage, {
            position: toast.POSITION.TOP_CENTER,
            hideProgressBar: true,
            autoClose: 3000,
            className: styles.toastSuccess
        });
    };
    const errorToast = (toastMessage) => {
        toast.error(toastMessage, {
            position: toast.POSITION.TOP_CENTER,
            hideProgressBar: true,
            autoClose: 3000
        });
    };
    const handleUATSubmit = () => {
        setMessage({
            announcementType: state.announcement.announcementType,
            message: textMessage !== '' ? textMessage : state.announcement.message,
            environment: state.announcement.environment,
            description: state.announcement.description,
            lastModifiedDateTime: state.announcement.lastModifiedDateTime,
            lastModifiedUserName: state.announcement.lastModifiedUserName
        });
        setIsSubmittedToUat(true);
        if (textMessage !== '' || state.announcement.message) {
            setShowEditIcon(false);
            //setIsSubmittedToUat(false);
        }

        //handleUATSubmitClose()
        const indexObj = {};
        indexObj["testBox"] = false;
        setNotShowPlayButton(indexObj);
    }
    const handleUATSubmitClose = () => {
        if (announcementMessage.message.trim() !== '') {
            setIsSubmittedToUat(true);
        }
        else {
            setShowEditIcon(true);
        }
        setMessage({
            ...announcementMessage,
            message: state.announcement.message,
        });

        const indexObj = {};
        indexObj["testBox"] = false;
        setNotShowPlayButton(indexObj);
    }
    const handleEditIcon = () => {
        setShowEditIcon(false);
    }
    const handleChange = (event) => {
        const indexObj = {};
        indexObj["testBox"] = false;
        setNotShowPlayButton(indexObj);
        if (CHARACTER_LIMIT >= event.target.value.length) {
            setTextMessage(event.target.value);
            setMessage({
                announcementType: state.announcement.announcementType,
                message: event.target.value,
                environment: state.announcement.environment,
                description: state.announcement.description,
                lastModifiedDateTime: state.announcement.lastModifiedDateTime,
                lastModifiedUserName: state.announcement.lastModifiedUserName
            });
        }

    }
    const handleMessageClick = () => {
        setIsSubmittedToUat(false);
        setShowEditIcon(false)
    }
    const handleProdSubmit = () => {
        dispatch(saveAnnouncementsStart(
            {
                'Announcements': {
                    announcementType: announcementMessage.announcementType,
                    message: announcementMessage.message
                },
                environment: isProdSubmit ? ENVIRONMENT_tYPE.LIVE : ENVIRONMENT_tYPE.STAGING,
                isUpdate:true
            }));
    }
    useEffect(() => {
        if (announcementState && announcementState.isSaved) {
            successToast("Successfully Saved");
            setShowSubmitAlertModal(false);
            history.push('/announcements/' + groupType);
            //dispatch(fetchRoadConditionsStart());
        }
    }, [announcementState.isSaved]);
    useEffect(() => {
        if (announcementState && announcementState.error) {
            // errorToast(announcementState.error);
            setShowSubmitAlertModal(false)
        }
    }, [announcementState.error]);
    const showSubmitAlert = (env) => {
        setShowSubmitAlertModal(true);
        if (env === ENVIRONMENT_tYPE.LIVE) {
            setIsProdSubmit(true);
        }
        else {
            setIsProdSubmit(false);
        }
    };
    const onsubmitAlertHide = () => {
        setShowSubmitAlertModal(false);
    }
    const fetchAudio = (textMessage, index) => {
        if (textMessage && textMessage.trim() !== '') {
            const indexObj = {};
            indexObj[index] = true;
            setNotShowPlayButton(indexObj);
            dispatch(fetchAnnouncementaudioAudioStart(textMessage));
            setIsPreviewed(true);
        }

    }
    const [openPopOver, setOpenPopOver] = useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const handlePopOverClick = (event) => {
        setOpenPopOver(true);
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
        setOpenPopOver(false);
    };
    const handleDelete = (index, menuOption) => {
        setShowDeleteModal(true);
        handleClose();
    };
    const handleClear = () => {
        setMessage({
            announcementType: state.announcement.announcementType,
            message: "",
            environment: state.announcement.environment,
            description: state.announcement.description,
            lastModifiedDateTime: state.announcement.lastModifiedDateTime,
            lastModifiedUserName: state.announcement.lastModifiedUserName
        });
        setShowEditIcon(true);
        setIsSubmittedToUat(false);
        handleClose();
    };

    const onDeleteDiscard = () => {
        setShowDeleteModal(false);
    }
    const onDeleteSave = () => {
        dispatch(saveAnnouncementsStart({
            'Announcements': { announcementType: state?.announcement?.announcementType, message: '' },
            environment: announcementMessage.environment === ENVIRONMENT_tYPE.LIVE ? ENVIRONMENT_tYPE.LIVE : ENVIRONMENT_tYPE.STAGING
        }))
        setShowDeleteModal(false);
    }
    const onDeleteHide = () => {
        setShowDeleteModal(false);
    }
    return (
        <>
            <div>
                <Header />

                {showDeleteModal &&
                    <DeleteAlert
                        onSave={onDeleteSave}
                        onDiscard={onDeleteDiscard}
                        onHide={onDeleteHide}
                        show={showDeleteModal}
                        title={"Deleting Avalanche"}
                        modalMessage={isProdSubmit ? LIVE_DELETE_MESSAGE : STAGING_DELETE_MESSAGE}
                        modalBody={[announcementMessage.description]} />
                }
                {showSubmitAlertModal &&
                    <SubmitAlertModal
                        onSave={handleProdSubmit}
                        onDiscard={onsubmitAlertHide}
                        onHide={onsubmitAlertHide}
                        show={showSubmitAlertModal}
                        modalBody={[announcementMessage.description]}
                        modalTitle="Message Update"
                        modalMessage={announcementMessage.environment === ENVIRONMENT_tYPE.LIVE ? LIVE_MODALMESSAGE : STAGING_MODALMESSAGE}
                    />
                }
                <div className={classes.pageMargin}>
                    <Breadcrumb items={breacrumbItems}></Breadcrumb>
                    <a title="Help" className={styles.helpIcon} target="_blank" href={process.env.REACT_APP_BASE_URL + "/help/transport-ivr-messaging-application-help-avalanche-08062021/content/index.html"}>
                        <HelpOutline className="icon" style={{ fontSize: "30px" }} />
                    </a>
                    <ToastContainer className={styles.toastContainer} />
                    <Paper className={classes.root} elevation={0}>
                        <div className="row">
                            <div className="col col-12">
                                <span className={styles.fs30}>{state?.announcement?.description}</span>
                            </div>
                        </div>
                        <div >

                            {announcementMessage.environment === 'Live' ?
                                <div className={classes.rectBox}>
                                    <div className="row">
                                        <div className={"col col-xs-8 col-md-8 " + styles.middleAlign}>
                                            {state?.announcement?.environment === ENVIRONMENT_tYPE.LIVE ? 'Live Production IVR' : 'Staging IVR'}
                                        </div>
                                        <div className={"col col-xs-4 col-md-4 " + styles.rightAlign}>
                                            <Button color="primary" onClick={() => handleDelete('1', state?.announcement?.environment)}>Delete</Button>
                                        </div>
                                    </div>
                                    <Toolbar className={styles.border + " " + (state?.announcement?.environment === 'Live' ? styles.leftGreenBorder : styles.leftGreyBorder)} style={{ background: "#f0f3f4", minHeight: "63px", padding: "0" }} disableGutters={false}>

                                        <div className={"row " + styles.fullWidth}>

                                            <div className={"col col-xs-12 col-md-12 " + styles.rightAlign}>
                                                {!isNotShowPlayButton['readOnlyBox'] ? <Button onClick={() => fetchAudio(state?.announcement?.message, 'readOnlyBox')} > <PlayCircleFilledIcon style={{ color: "#c60c30", fontSize: "30px" }} /></Button> :
                                                    (audioState.loading ? <CircularProgress /> :
                                                        <audio controls autoPlay style={{ top: "3px", position: "relative", width: "100%" }}>
                                                            <source src={audioState.audioResponse} type="audio/wav" ></source>
                                                        </audio>)}
                                            </div>

                                        </div>
                                    </Toolbar>

                                    <TextField
                                        id="outlined-secondary"
                                        variant="outlined"
                                        InputProps={{
                                            classes: {
                                                input: styles.fs14,
                                            },
                                            readOnly: true
                                        }
                                        }
                                        multiline
                                        fullWidth
                                        readOnly
                                        rows={5}
                                        color="primary"
                                        defaultValue={state?.announcement?.message}
                                    />
                                </div>
                                : <>
                                    <div className={classes.rectBox}>
                                        <div className="row">
                                            <div className={"col col-xs-8 col-md-8 " + styles.middleAlign}>
                                                {announcementMessage.environment === ENVIRONMENT_tYPE.LIVE ? 'Live Production IVR' : (announcementMessage.environment === ENVIRONMENT_tYPE.STAGING ? 'Staging IVR' : 'Create IVR')}
                                            </div>
                                            <div className={"col col-xs-4 col-md-4 " + styles.rightAlign}>
                                                {(showEditIcon && !isSubmittedToUat) ?
                                                    <Button color="primary" onClick={handleEditIcon}>Add</Button> :
                                                    <Button color="primary" onClick={handleMessageClick}>Edit</Button>
                                                }


                                                <Button color="primary" onClick={handleClear}>Clear</Button>
                                                <Button color="primary" onClick={() => handleDelete('1', state?.announcement?.environment)}> Delete</Button>
                                            </div>
                                        </div>
                                        <Toolbar className={styles.border + " " + (state?.announcement?.environment === 'Live' ? styles.leftGreenBorder : styles.leftGreyBorder)} disableGutters={false} style={{ background: "#f0f3f4", minHeight: "63px", padding: "0" }} >
                                            <div className={"row " + styles.fullWidth}>
                                                <div className={"col col-xs-12 col-md-12 " + styles.rightAlign}>
                                                    {!isNotShowPlayButton['testBox'] ? <Button onClick={() => fetchAudio(textMessage === "" ? announcementMessage.message : textMessage, 'testBox')} > <PlayCircleFilledIcon style={{ color: "#c60c30", fontSize: "30px" }} /></Button> :
                                                        (audioState.loading ? <CircularProgress /> :
                                                            <audio controls autoPlay style={{ top: "3px", position: "relative", width: "100%" }}>
                                                                <source src={audioState.audioResponse} type="audio/wav" ></source>
                                                            </audio>)}
                                                </div>

                                            </div>
                                        </Toolbar>

                                        <div className={styles.h140}>
                                            {(showEditIcon && !isSubmittedToUat) ?
                                                (<div className="row" style={{ minHeight: '60px' }}>
                                                    <div className="col col-md-12 col-xs-12">

                                                    </div>

                                                </div>)
                                                :
                                                (isSubmittedToUat ?
                                                    <div className={"row " + styles.margin3}>
                                                        <ButtonBase className={classes.button} style={{ color: "black" }} onClick={handleMessageClick}><span style={{ textAlign: 'left' }}>{announcementMessage.message}</span></ButtonBase>
                                                    </div>
                                                    : <div className={"row " + styles.margin3}>
                                                        <TextField
                                                            id="outlined-secondary"
                                                            variant="outlined"
                                                            InputProps={{
                                                                classes: {
                                                                    input: styles.fs14,
                                                                },
                                                                maxLength: CHARACTER_LIMIT
                                                            }}
                                                            multiline
                                                            fullWidth
                                                            maxLength={CHARACTER_LIMIT}
                                                            rows={3}
                                                            color="primary"
                                                            value={announcementMessage.message}
                                                            onChange={handleChange}
                                                        />
                                                        <Button color="secondary" onClick={handleUATSubmit}>Continue</Button>
                                                        <Button color="primary" onClick={handleUATSubmitClose}>Cancel</Button>
                                                        <Typography gutterBottom variant="h5" component="h2" className={
                                                            (CHARACTER_LIMIT - 40 <= announcementMessage.message.length) ? styles.mltAuto + ' ' + styles.danger : styles.mltAuto}
                                                        >
                                                            {'Characters Left: ' + (CHARACTER_LIMIT - announcementMessage.message.length)}
                                                        </Typography>
                                                    </div>)

                                            }
                                            <div className="row">
                                            </div>
                                        </div>

                                    </div>
                                    <div className="row">
                                        <div className={"col col-xs-12 col-md-12 " + styles.rightAlign}>
                                            {isPreviewed && isSubmittedToUat && isNotShowPlayButton['testBox'] && <Button className={styles.submitButton} variant="contained" color="primary" disabled={!isSubmittedToUat} onClick={() => showSubmitAlert(ENVIRONMENT_tYPE.STAGING)}>Save to Staging</Button>}
                                            {isPreviewed && isSubmittedToUat && isNotShowPlayButton['testBox'] && <Button style={{ marginLeft: "20px" }} className={styles.submitButton} variant="contained" color="primary" disabled={!isSubmittedToUat} onClick={() => showSubmitAlert(ENVIRONMENT_tYPE.LIVE)}>Submit to Production</Button>}
                                        </div>
                                    </div>
                                </>
                            }
                        </div>
                    </Paper>
                    {!(isPreviewed && isSubmittedToUat && isNotShowPlayButton['testBox']) && <div style={{ color: "#c60c30" }}>*Messages must be played before they can be saved or submitted.</div>}
                </div>
                <div className={classes.marginTop}>
                    <Footer />
                </div>
            </div>
        </>
    );
}
export default EditorPage;
